import React from "react";
import "./style.css";
import Navbar from "../../Components/Navbar";

const Privacy = () => {
  return (
    <>
      <Navbar />
      <div className="privacy-container">
        <div className="privacy-content">
          <h1 className="title">Privacy Policy</h1>

          <p>
            <strong>Last updated:</strong> August 2026
          </p>

          <p>
            <strong>Memory Match</strong> (&quot;the app&quot;) is an offline
            memory card game published by CouSync.
          </p>

          <h2>Information We Collect</h2>
          <ul>
            <li>
              Game progress and preferences (such as best score, games played,
              sound settings, and theme choice) are stored locally on your
              device using on-device storage.
            </li>
            <li>
              We do not require an account and we do not collect your name,
              email address, or contact details through the app today.
            </li>
          </ul>

          <h2>Future Advertising</h2>
          <ul>
            <li>
              We plan to show ads in a future update. When ads are enabled,
              third-party ad partners (such as Google AdMob) may collect device
              identifiers, ad interaction data, and similar information to
              deliver and measure advertising. We will update this policy before
              ads go live and, where required, ask for your consent.
            </li>
          </ul>

          <h2>Children</h2>
          <p>
            The app is suitable for general audiences. If you are under the age
            required in your country to consent to data processing, please use
            the app with a parent or guardian.
          </p>

          <h2>Data Retention</h2>
          <p>
            Local game data remains on your device until you clear app storage
            or uninstall the app.
          </p>

          <h2>Your Choices</h2>
          <ul>
            <li>
              You can reset local progress by clearing the app&apos;s storage in
              your device settings.
            </li>
            <li>
              You can disable vibration and audio in Settings at any time.
            </li>
          </ul>

          <h2>Contact</h2>
          <p>
            For privacy questions, contact CouSync at{" "}
            <strong>contact@cousync.tech</strong>
          </p>

          <h2>Changes</h2>
          <p>
            We may update this policy from time to time. Continued use of the
            app after changes means you accept the updated policy.
          </p>
        </div>

        <footer className="privacy-footer">
          All rights reserved © CouSync
        </footer>
      </div>
    </>
  );
};

export default Privacy;
